import { createElement } from 'react';
import { styled } from '@mui/material/styles';
import MuiTooltip, { tooltipClasses } from '@mui/material/Tooltip';
import type { TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';

const TOOLTIP_ANCHOR_GAP_PX = 4;

const mergeClassNames = (...classNames: (string | undefined)[]) => classNames.filter(Boolean).join(' ');
const px = (value: number) => `${value}px`;

const TooltipWithPopperClassName = ({ className, classes, ...props }: MuiTooltipProps) =>
  createElement(MuiTooltip, {
    ...props,
    classes: {
      ...classes,
      popper: mergeClassNames(classes?.popper, className),
    },
  });

export const StyledTooltip = styled(TooltipWithPopperClassName)(({ theme }) => ({
  [`&.${tooltipClasses.popper}`]: {
    pointerEvents: 'none',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    borderRadius: px(theme.shape.radius?.xs ?? 4),
    fontFamily: theme.typography.fontFamily,
    fontSize: '11px',
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: '15px',
    maxWidth: '240px',
    padding: '4px 7px',
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]: {
    marginBottom: px(TOOLTIP_ANCHOR_GAP_PX),
  },
  [`&[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
    marginTop: px(TOOLTIP_ANCHOR_GAP_PX),
  },
  [`&[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]: {
    marginRight: px(TOOLTIP_ANCHOR_GAP_PX),
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]: {
    marginLeft: px(TOOLTIP_ANCHOR_GAP_PX),
  },
  [`& .${tooltipClasses.arrow}`]: {
    fontSize: '8px',
  },
}));
